module.exports = __webpack_public_path__ + "img/icon7.03c79cb9.svg";